var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-content account" }, [
    !_vm.accountSummaryFlow && _vm.isLoggedIn
      ? _c(
          "div",
          { staticClass: "playbalance" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("Account.PlayBalance")))]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "total-balance",
                attrs: { id: "qa-total-balance" }
              },
              [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("Account.PlayBalance.TotalBalance")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "val" }, [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.totalBalance)))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "trading-balance",
                attrs: { id: "qa-trading-balance" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "trading-balance-header",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.toggleTradingBalance = !_vm.toggleTradingBalance
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Account.PlayBalance.TradingBalance"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "val" }, [
                      _vm._v(_vm._s(_vm._f("currency")(_vm.tradingBalance)))
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.toggleTradingBalance,
                            expression: "!toggleTradingBalance"
                          }
                        ],
                        staticClass: "chevron_down"
                      },
                      [_vm._v("expand_more")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.toggleTradingBalance,
                            expression: "toggleTradingBalance"
                          }
                        ],
                        staticClass: "chevron_up"
                      },
                      [_vm._v("expand_less")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.toggleTradingBalance
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "balance-info tradingbalance" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.PlayBalance.TradingBalanceInfo")
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "withdrawal-balance" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.PlayBalance.WithdrawalBalance")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "val" }, [
                          _vm._v(
                            _vm._s(_vm._f("currency")(_vm.withdrawalBalance))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "balance-info withdrawalbalance" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.PlayBalance.WithdrawalBalanceInfo"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.brandKey !== "boyd" ||
                      (_vm.brandKey === "boyd" && _vm.promoBalance)
                        ? _c("div", { staticClass: "promo-balance" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Account.PlayBalance.PromoBalance")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "val" }, [
                              _vm._v(
                                _vm._s(_vm._f("currency")(_vm.promoBalance))
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "balance-info withdrawalbalance" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.PlayBalance.PromoBalanceInfo")
                            )
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "locked-funds", attrs: { id: "qa-locked-funds" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "locked-funds-header",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.toggleLockedFunds = !_vm.toggleLockedFunds
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("Account.PlayBalance.LockedFunds")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "val" }, [
                      _vm._v(_vm._s(_vm._f("currency")(_vm.lockedFunds)))
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.toggleLockedFunds,
                            expression: "!toggleLockedFunds"
                          }
                        ],
                        staticClass: "chevron_down"
                      },
                      [_vm._v("expand_more")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.toggleLockedFunds,
                            expression: "toggleLockedFunds"
                          }
                        ],
                        staticClass: "chevron_up"
                      },
                      [_vm._v("expand_less")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.toggleLockedFunds
                  ? _c("div", { staticClass: "balance-info lockedfunds" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Account.PlayBalance.LockedFundsInfo"))
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("pending-transactions")
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.accountSummaryFlow && _vm.isLoggedIn
      ? _c("div", { staticClass: "playbalance" }, [
          _c(
            "div",
            { staticClass: "total-balance", attrs: { id: "qa-total-balance" } },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("Account.PlayBalance.TotalBalance")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "val" }, [
                _vm._v(_vm._s(_vm._f("currency")(_vm.totalBalance)))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "trading-balance",
              attrs: { id: "qa-trading-balance" }
            },
            [
              _c("div", { staticClass: "trading-balance-header" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("Account.PlayBalance.TradingBalance")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "val" }, [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.tradingBalance)))
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "balance-info tradingbalance" }, [
                  _vm._v(
                    _vm._s(_vm.$t("Account.PlayBalance.TradingBalanceInfo"))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "withdrawal-balance" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Account.PlayBalance.WithdrawalBalance"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "val" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.withdrawalBalance)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "balance-info withdrawalbalance" }, [
                  _vm._v(
                    _vm._s(_vm.$t("Account.PlayBalance.WithdrawalBalanceInfo"))
                  )
                ]),
                _vm._v(" "),
                _vm.brandKey !== "boyd" ||
                (_vm.brandKey === "boyd" && _vm.promoBalance)
                  ? _c("div", { staticClass: "promo-balance" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Account.PlayBalance.PromoBalance"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "val" }, [
                        _vm._v(_vm._s(_vm._f("currency")(_vm.promoBalance)))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "balance-info withdrawalbalance" }, [
                  _vm._v(_vm._s(_vm.$t("Account.PlayBalance.PromoBalanceInfo")))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "locked-funds", attrs: { id: "qa-locked-funds" } },
            [
              _c("div", { staticClass: "locked-funds-header" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("Account.PlayBalance.LockedFunds")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "val" }, [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.lockedFunds)))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "balance-info lockedfunds" }, [
                _vm._v(_vm._s(_vm.$t("Account.PlayBalance.LockedFundsInfo")))
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e6927c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6927c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountPlayBalanceComponent.vue
// module id = null
// module chunks = 